import type { ReactNode } from 'react';

import Tooltip, { type TooltipDelay } from '@/components/atoms/Tooltip';

import styles from './GroupTrack.module.scss';

/**
 * A short wait before a lane's tooltips show, so moving the pointer along a row (which lights
 * the group under it) doesn't flash a bubble over every bar it crosses.
 */
export const TRACK_TIP_DELAY: TooltipDelay = { show: 300, hide: 0 };

interface TrackTipProps {
    content: string;
    /** What the pointer rests on; by default an empty area filling the positioned parent. */
    children?: ReactNode;
}

/**
 * The board's styled tooltip on something drawn on a lane (a bar, a tick, a marker), in place
 * of a native `title`. It fills its positioned parent, which sets where and how wide it is.
 */
export default function TrackTip(props: TrackTipProps) {
    const { content, children } = props;
    return (
        <Tooltip
            content={content}
            layout="fill"
            delay={TRACK_TIP_DELAY}
            targetClassName={styles.tipTarget}>
            {children ?? <span className={styles.tipFill} />}
        </Tooltip>
    );
}
